<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qE2nu8/images/cover.jpg?1685203881300" alt="This image is the cover for the book The Reiki Teacher's Manual - Second Edition"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Reiki Teacher's Manual - Second Edition
      </h1>
      <p class="bookDescription body article font2">
        <b>Is it time to unlock the teacher within you?</b><br/><br/><i>The Reiki Teacher's Manual (Second Edition)</i> sets the standard for Reiki education.<br/><br/>This book is designed for students, practitioners, and teachers. This enhanced new edition will enrich the classes for current teachers and gives the new teacher confidence and pride when providing that very first class. Practitioners will have a greater understanding of how to apply Reiki and what is actually happening during a session. This manual provides: <br/>•A quick reference to answer student's questions.<br/>•Consecutive steps with time approximations.<br/>•How to structure hands-on practice sessions.<br/>•How to increase the power of your attunement;<br/>•How to teach the attunement to others.<br/>•Gaols to achieve.<br/>•Detailed descriptions and sues for the symbols.<br/>•Fifteen handouts that are concise, informative, and can be copied from the book.<br/>•A list of supplies for each class.<br/><br/><b>As a practitioner, you will never be afraid or even worried about teaching a Reiki class or giving attunements. Your students will be grateful and confident for the rich content your classes give.<b></b></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tina M. Zion
      </h2>
      
      <p class="authorDescription body article">Tina M. Zion is a fourth generation intuitive medium, specializing in medical intuition and teaching it internationally. She has worked in the mental health field as a registered nurse with a national board specialty certification in mental health nursing from the American Nurses Credentialing Association. Tina is a Gestalt trained counselor, graduating from the Indianapolis Gestalt Institute in 1997. She received her certification in clinic hypnotherapy from the American Council of Hypnotist Examiners in 1985, specializing in past life regressions and certified through the Michael Newton Institute. She has been a Reiki practitioner and teacher since 1991. Tina is the global bestselling author of author of <i>Become a Medical Intuitive, Advanced Medical Intuition, Reiki and Your Intuition, The Reiki Teacher's Manual,</i> and she is a contributing author in Michael Newton's book "Memories of the Afterlife." <br><br>Tina's private practice now focuses completely on teaching medical intuition through online courses, workshops, and individual mentoring sessions. Tina teaches her workshop, Become a Medical Intuitive: Seeing with X-Ray Eyes, in Canada, the UK, Europe, New Zealand, Australia, and throughout the U.S.<br><br>Visit her website at www.tinazion.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Boutique of Quality Books Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c426a84c